import $ from "jquery";
import "signalr";
import moduleLoader from "flow/wrappers/moduleLoader";
import eventSystem from "flow/events/eventSystem";
import config from "flow/config";
import metaCache from "flow/utils/metaCache";
import MyFlow from "flow/MyFlow";

let theFlow: MyFlow;
let isInitialized = false;
const retryLimit = 5;
let retryAttempts = 0;
let debounce = false;

type EventPost = {
    Topic: string;
    Data: any;
};

function getEventHub(connection: SignalR): any {
    return (connection as any).eventHub;
}

// SignalR (against WE.Notifications.Web)
function publishTopics() {
    if (eventSystem.webSocketTopics().length > 0 && $.connection.hub.state === 1) {
        getEventHub($.connection)
            .server.startPublish(eventSystem.webSocketTopics())
            .done(() => {
                console.log("Connected to SignalR hubs");
            })
            .fail((err: Error) => {
                console.log("Error connecting to SignalR hub: " + err);
            });
    }
}

function startConnection() {
    $.connection.hub
        .start(function () {
            console.log("Hub started");
            publishTopics();
        })
        .fail(function () {
            console.log("Failed to start hub");
        });
}

function initializeChannel() {
    try {
        $.connection.hub.url = config.partialUrls.weNotificationsWeb + "signalr";

        getEventHub($.connection).client.publishEvent = (data: EventPost) => {
            theFlow.publish(data.Topic, data.Data);
        };

        startConnection();

        $.connection.hub.disconnected(() => {
            if (debounce) {
                return;
            }

            debounce = true;

            setTimeout(() => {
                debounce = false;
                if (eventSystem.webSocketTopics().length > 0) {
                    if (retryAttempts++ < retryLimit) {
                        $.connection.hub.start(() => {
                            getEventHub($.connection).server.startPublish(eventSystem.webSocketTopics());
                        });
                    }
                }
            }, 5000); // Restart connection after 5 seconds.
        });
    } catch (e) {
        console.log("Error in connecting to signalR hub: " + e.toString());
    }
}

function stopChannel() {
    if (!isInitialized) {
        return;
    }

    try {
        $.connection.hub.stop();
        retryAttempts = 0;
        console.log("Hub stopped");
    } catch (e) {
        console.log("Error in explicitly disconnecting signalR hub: " + e.toString());
    }
}

function publishChanges(changes: KnockoutArrayChange<string>[]) {
    const newTopicsForAll: string[] = [];
    const removedTopicsForAll: string[] = [];

    changes.forEach(change => {
        if (change.status === "added") {
            newTopicsForAll.push(change.value);
        } else if (change.status === "deleted") {
            removedTopicsForAll.push(change.value);
        }
    });

    if ($.connection.hub.state === 1) {
        if (newTopicsForAll.length > 0) {
            getEventHub($.connection)
                .server.startPublish(newTopicsForAll)
                .done(() => {
                    console.log("Connected to SignalR hubs");
                })
                .fail((err: Error) => {
                    console.log("Error connecting to SignalR hub : " + err);
                });
        }
        if (removedTopicsForAll.length > 0) {
            getEventHub($.connection)
                .server.stopPublish(removedTopicsForAll)
                .done(() => {
                    console.log("Connected to SignalR hubs");
                })
                .fail((err: Error) => {
                    console.log("Error connecting to SignalR hub : " + err);
                });
        }
    }
}
// End SignalR

function init(myFlow: MyFlow) {
    if (isInitialized === true) return;

    theFlow = myFlow;

    const disableSignalR = metaCache.lookup("Common.Features.DisableSignalRCommunication", false);

    if (disableSignalR === false || disableSignalR === "False") {
        function onTopicListChanged(changes: KnockoutArrayChange<string>[]) {
            if (eventSystem.webSocketTopics().length > 0) {
                if ($.connection == null || !getEventHub($.connection)) {
                    moduleLoader.requireAsync(["signalrHubs"]).then(function () {
                        initializeChannel();
                    });
                } else {
                    if ($.connection.hub.state === 4) startConnection();
                    else publishChanges(changes);
                }
            } else {
                stopChannel();
            }
        }

        eventSystem.webSocketTopics.subscribe(onTopicListChanged, null, "arrayChange");
        onTopicListChanged([]); // Initial pass over list
    }

    isInitialized = true;
}

export default {
    init: init
};
